import { Link, Navigate, Outlet, useOutletContext, useParams } from "react-router-dom";
import { MIDPOINT_MEDIA_ADMIN_PORTAL_BASE } from "../../constants/clientAdminPortalRoutes";
import { useClientPortalBase, useClientPortalPaths } from "../../hooks/useClientPortalBase";
import ClientSettingsSubnav from "./ClientSettingsSubnav";

export default function ClientSettingsHubLayout() {
  const { clientViewId } = useParams();
  const outletContext = useOutletContext() || {};
  const { permissions } = outletContext;
  const portalBase = useClientPortalBase();
  const paths = useClientPortalPaths();
  const isMidpointMedia = portalBase === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;

  const canAccessSettings = Boolean(permissions?.manageSettings || permissions?.manageIam);

  if (!canAccessSettings) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return (
    <div className="cp-settings-page">
      <header className="panel-card cp-settings-header">
        <p className="eyebrow">
          {isMidpointMedia ? (
            "Workspace"
          ) : (
            <Link to={paths.view(clientViewId)}>Client View</Link>
          )}{" "}
          / Settings
        </p>
        <h2>Settings</h2>
        <p className="muted cp-settings-lead">
          {isMidpointMedia
            ? "Website analytics, outbound notifications, and administrative activity for Midpoint Media. Invite teammates from People → Accounts."
            : "Manage team access, integrations, data sources, and audit history for this view."}
        </p>
        {isMidpointMedia ? null : <ClientSettingsSubnav clientViewId={clientViewId} />}
      </header>
      <Outlet context={outletContext} />
    </div>
  );
}
